import './App.css';
import LandingPage from './landingPage/LandingPage';
import './assets/css/Style.css'
import { Routes, Route, HashRouter } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
